export default __webpack_public_path__ + "static/media/EQ200_Logo_wh2.7cf1c0dd.png";